import { styled } from "@mui/material";


const StyledChatHeader = styled('div')`
  display: flex;
  align-items: center;
  column-gap: 12px;


  .chat-header {

    &__user-img-wrapper, &__product-img-wrapper {
      & > div, & img {
        width: 100%;
        height: 100%;
        object-position: center;
      }
    }

    &__user-img-wrapper {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: ${props => props.theme.customTheme.colors.secondary};
      overflow: hidden;
      flex-shrink: 0;

      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    &__product-img-wrapper {
      width: 80px;
      height: 80px;
      border-radius: 10px;
      background-color: ${props => props.theme.customTheme.colors.secondary};
      overflow: hidden;
      flex-shrink: 0;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__text-wrapper {
      flex-grow: 1;
    }

    &__title {
      font-size: ${props => props.theme.customTheme.sizes.middle};
      line-height: 1.5;
      line-height: 1.5;
      font-weight: 600;
      color: ${props => props.theme.customTheme.colors.dark};

      margin-top: 0;
      margin-bottom: 8px;

      // NOTE 1 qator uchun
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__description {
      font-size: ${props => props.theme.customTheme.sizes.middle};
      line-height: 1.5;
      line-height: 1.5;
      font-weight: 400;
      color: ${props => props.theme.customTheme.colors.dark};

      margin: 0;

      // NOTE 1 qator uchun
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }


  @media (max-width: 767.98px) {
    column-gap: 6px;

    .chat-header {

      &__user-img-wrapper {
        width: 50px;
        height: 50px;
      }

      &__product-img-wrapper {
        width: 50px;
        height: 50px;
      }

      &__text-wrapper {}

      &__title {
        font-size: ${props => props.theme.customTheme.sizes.small};
        margin-bottom: 0;
      }
      
      &__description {
        font-size: ${props => props.theme.customTheme.sizes.xSmall};
      }

    }
  }
`;

export {
  StyledChatHeader,
};
